import React from 'react';
import Link from '@/lighting-app/compat/NextLink';
import { PenTool, Search, ArrowLeft } from 'lucide-react';

export default function MainCTACards() {
  return (
    <section className="section-bg-white py-20" id="main-tools">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-foreground mb-3">ماذا تريد أن تفعل؟</h2>
          <p className="text-muted-foreground text-lg">اختر الأداة المناسبة لاحتياجك</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Design Card */}
          <div className="group relative bg-card rounded-2xl p-8 border-2 border-border hover:border-primary card-shadow hover:card-shadow-hover transition-all duration-300 cursor-pointer overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 gradient-primary opacity-0 group-hover:opacity-100 transition-opacity" />

            <div className="w-16 h-16 rounded-2xl gradient-primary flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
              <PenTool size={28} className="text-white" />
            </div>

            <h3 className="text-2xl font-bold text-foreground mb-3">صمّم إضاءة جديدة</h3>
            <p className="text-muted-foreground leading-relaxed mb-6">
              احسب عدد المصابيح، شدة الإضاءة والتوزيع المناسب لمكانك. يعتمد على طريقة Lumen Method الهندسية.
            </p>

            <ul className="space-y-2 mb-8">
              {[
                'عدد المصابيح المطلوبة',
                'مستوى Lux المناسب',
                'مخطط توزيع الإنارة',
                'استهلاك الطاقة الكلي',
              ]?.map((item) => (
                <li key={`design-feature-${item}`} className="flex items-center gap-2 text-sm text-secondary">
                  <span className="w-5 h-5 rounded-full bg-accent flex items-center justify-center flex-shrink-0">
                    <span className="text-primary text-xs">✓</span>
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <Link
              href="/design-new-lighting-wizard"
              className="btn-primary w-full py-4 text-base font-bold rounded-xl flex items-center justify-center gap-3 group/btn"
            >
              <span>ابدأ التصميم</span>
              <ArrowLeft size={18} className="group-hover/btn:-translate-x-1 transition-transform" />
            </Link>
          </div>

          {/* Inspect Card */}
          <div className="group relative bg-card rounded-2xl p-8 border-2 border-border hover:border-secondary card-shadow hover:shadow-lg transition-all duration-300 cursor-pointer overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 gradient-dark opacity-0 group-hover:opacity-100 transition-opacity" />

            <div className="w-16 h-16 rounded-2xl gradient-dark flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
              <Search size={28} className="text-white" />
            </div>

            <h3 className="text-2xl font-bold text-foreground mb-3">افحص إضاءة موجودة</h3>
            <p className="text-muted-foreground leading-relaxed mb-6">
              قيّم الإضاءة الحالية واعرف إن كانت مناسبة أو تحتاج تحسين. مع توصيات دقيقة للتعديل.
            </p>

            <ul className="space-y-2 mb-8">
              {[
                'تقييم مستوى Lux الحالي',
                'مقارنة بالمعايير الدولية',
                'عدد المصابيح المطلوب إضافتها',
                'تقرير تفصيلي بالتوصيات',
              ]?.map((item) => (
                <li key={`inspect-feature-${item}`} className="flex items-center gap-2 text-sm text-secondary">
                  <span className="w-5 h-5 rounded-full bg-muted flex items-center justify-center flex-shrink-0">
                    <span className="text-secondary text-xs">✓</span>
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <Link
              href="/inspect-existing-lighting-wizard"
              className="btn-secondary w-full py-4 text-base font-bold rounded-xl flex items-center justify-center gap-3 group/btn"
            >
              <span>ابدأ الفحص</span>
              <ArrowLeft size={18} className="group-hover/btn:-translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}